var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.findAttributeOnSiteInfo('registerType')[0] == 0)?_c('NormalRegister',{staticClass:"my-5",attrs:{"image":_vm.image}}):_c('RegisterWithVerifyCellPhone',{attrs:{"image":_vm.image}})}
var staticRenderFns = []

export { render, staticRenderFns }